import type { CSSObject } from 'tss-react';
import { Theme } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';

export const usePageTitleStyles = makeStyles()(({ typography, breakpoints }: Theme) => ({
  root: {
    [breakpoints.up('sm')]: {
      ...(typography.h3 as CSSObject),
    },
  },
}));
